/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Shop_Tier_Min_Spend_InvalidInputs */

const vi_error_shop_tier_min_spend_invalid = /** @type {(inputs: Error_Shop_Tier_Min_Spend_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mốc chi tiêu phải là số tiền nguyên từ 0 đến ${i?.max}.`)
};

/**

* @param {Error_Shop_Tier_Min_Spend_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_tier_min_spend_invalid = /** @type {((inputs: Error_Shop_Tier_Min_Spend_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Tier_Min_Spend_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_tier_min_spend_invalid(inputs)
});